import { FloraTypography } from '@grupoboticario/flora-react'

export const CatalogTitle = () => {
  return (
    <FloraTypography
      fontSize="subtitle"
      viewport="mobile"
      autotagging-flora="on"
    >
      Conheça as ofertas deste ciclo
    </FloraTypography>
  )
}
